(function(){
  var SIZE_VARIANTS = {
    'S':   52148159217944,
    'M':   52148497056024,
    'L':   52148497088792,
    'XL':  52148497121560,
    '2XL': 52148497154328,
    '3XL': 52148497187096
  };

  function init(){
    if(typeof CFG==='undefined') return;
    var placeholder=document.querySelector('script[src*="custom-product-options"]');
    if(!placeholder||document.getElementById('copo-wrap')) return;

    var html='<div id="copo-wrap" style="margin-bottom:1.5rem">';
    html+='<div style="margin-bottom:1rem"><label style="display:block;font-size:13px;font-weight:500;margin-bottom:6px">Style</label>';
    html+='<select id="copo-style" style="width:100%"><option value="">— select style —</option>';
    for(var i=0;i<CFG.styles.length;i++) html+='<option value="'+CFG.styles[i].key+'">'+CFG.styles[i].label+'</option>';
    html+='</select></div>';
    html+='<div style="margin-bottom:1rem"><label style="display:block;font-size:13px;font-weight:500;margin-bottom:6px">Brand</label>';
    html+='<select id="copo-brand" disabled style="width:100%"><option value="">— select brand —</option></select></div>';
    html+='<div style="margin-bottom:1rem"><label style="display:block;font-size:13px;font-weight:500;margin-bottom:6px">Color: <span id="copo-color-name"></span></label>';
    html+='<div id="copo-swatches" style="display:flex;flex-wrap:wrap;gap:4px;margin-top:4px"></div></div>';
    html+='<div style="margin-bottom:1rem"><label style="display:block;font-size:13px;font-weight:500;margin-bottom:6px">Size</label>';
    html+='<select id="copo-size" style="width:100%"><option value="">— select size —</option>';
    html+='<option value="S">S</option><option value="M">M</option><option value="L">L</option>';
    html+='<option value="XL">XL</option><option value="2XL">2XL</option><option value="3XL">3XL</option>';
    html+='</select><p style="font-size:11px;color:#888;margin-top:4px">Unisex sizing — when in doubt, size up.</p></div>';
    html+='<p id="copo-price" style="font-size:1.1rem;font-weight:500;margin:0 0 1rem"></p>';
    html+='<button id="copo-btn" type="button" style="width:100%;padding:15px;background:#1c1c1c;color:#fff;border:none;font-size:16px;cursor:pointer;letter-spacing:0.1em">ADD TO CART</button>';
    html+='<p id="copo-msg" style="color:red;margin-top:8px;font-size:13px"></p>';
    html+='</div>';

    var div=document.createElement('div');
    div.innerHTML=html;
    placeholder.parentNode.insertBefore(div,placeholder);

    document.getElementById('copo-style').addEventListener('change',updateBrand);
    document.getElementById('copo-brand').addEventListener('change',updateColors);
    document.getElementById('copo-size').addEventListener('change',updatePrice);
    document.getElementById('copo-btn').addEventListener('click',addToCart);
  }

  var selBrand=null,selColor=null,selSize=null;

  function updateBrand(){
    var s=document.getElementById('copo-style').value;
    var b=document.getElementById('copo-brand');
    b.innerHTML='<option value="">— select brand —</option>';
    b.disabled=true;
    document.getElementById('copo-swatches').innerHTML='';
    document.getElementById('copo-color-name').textContent='';
    document.getElementById('copo-price').textContent='';
    selBrand=null;selColor=null;selSize=null;
    if(!s)return;
    var style=null;
    for(var i=0;i<CFG.styles.length;i++){if(CFG.styles[i].key===s){style=CFG.styles[i];break;}}
    if(!style)return;
    b.disabled=false;
    for(var j=0;j<style.brands.length;j++){
      var o=document.createElement('option');
      o.value=style.brands[j].key;
      o.textContent=style.brands[j].label+' — from $'+style.brands[j].base;
      b.appendChild(o);
    }
  }

  function updateColors(){
    var s=document.getElementById('copo-style').value;
    var bk=document.getElementById('copo-brand').value;
    document.getElementById('copo-swatches').innerHTML='';
    document.getElementById('copo-color-name').textContent='';
    document.getElementById('copo-price').textContent='';
    selBrand=null;selColor=null;
    if(!s||!bk)return;
    var style=null,brand=null;
    for(var i=0;i<CFG.styles.length;i++){if(CFG.styles[i].key===s){style=CFG.styles[i];break;}}
    if(!style)return;
    for(var j=0;j<style.brands.length;j++){if(style.brands[j].key===bk){brand=style.brands[j];break;}}
    if(!brand)return;
    selBrand=brand;
    document.getElementById('copo-price').textContent='From $'+brand.base+'.00';
    var box=document.getElementById('copo-swatches');
    var light=['#F8F8F8','#F5F0E1','#F5E6A3','#DDD8CC','#ACACA6','#F4C0C8','#F0A0B0','#E8A0B0'];
    for(var k=0;k<brand.colors.length;k++){
      (function(c){
        var sw=document.createElement('div');
        sw.title=c.name;
        sw.style.cssText='width:26px;height:26px;border-radius:50%;background:'+c.hex+';cursor:pointer;border:2px solid transparent;flex-shrink:0;display:inline-block;margin:3px';
        for(var l=0;l<light.length;l++){if(light[l]===c.hex){sw.style.border='2px solid #ccc';break;}}
        sw.addEventListener('click',function(){
          var all=document.querySelectorAll('#copo-swatches div');
          for(var m=0;m<all.length;m++) all[m].style.outline='none';
          sw.style.outline='3px solid #000';sw.style.outlineOffset='2px';
          selColor=c.name;
          document.getElementById('copo-color-name').textContent=c.name;
          updatePrice();
        });
        box.appendChild(sw);
      })(brand.colors[k]);
    }
  }

  function updatePrice(){
    selSize=document.getElementById('copo-size').value;
    if(!selBrand||!selSize)return;
    var p=selBrand.base;
    if(selSize==='2XL')p+=selBrand.u2;
    if(selSize==='3XL')p+=selBrand.u3;
    document.getElementById('copo-price').textContent='$'+p.toFixed(2);
  }

  function addToCart(){
    var styleEl=document.getElementById('copo-style');
    var brandEl=document.getElementById('copo-brand');
    var msg=document.getElementById('copo-msg');
    msg.textContent='';
    if(!styleEl.value||!brandEl.value||!selColor||!selSize){
      msg.textContent='Please select a Style, Brand, Color, and Size.';
      return;
    }
    var vid=SIZE_VARIANTS[selSize];
    var btn=document.getElementById('copo-btn');
    btn.textContent='Adding...';
    btn.disabled=true;
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify({
        id:vid,
        quantity:1,
        properties:{
          'Style':styleEl.options[styleEl.selectedIndex].text,
          'Brand':brandEl.options[brandEl.selectedIndex].text,
          'Color':selColor,
          'Size':selSize
        }
      })
    })
    .then(function(r){return r.json();})
    .then(function(data){
      if(data.status&&data.status!==200){
        msg.textContent='Error: '+data.description;
        btn.textContent='ADD TO CART';
        btn.disabled=false;
      } else {
        window.location.href='/cart';
      }
    })
    .catch(function(err){
      msg.textContent='Error: '+err.message;
      btn.textContent='ADD TO CART';
      btn.disabled=false;
    });
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();